// extracted by mini-css-extract-plugin
export default {"background":"_3AJdF8Yh8bkPmLNX4M0LJi","foreground":"_3BlGkYxLTM5B19rUsmfNqX","companyColor":"_1Ush2X3BEginRztfpQLJwD"};